import { Trans } from '@lingui/react/macro';
import { createFileRoute } from '@tanstack/react-router';

/** Where an external participant lands after finishing their interview. */
export const Route = createFileRoute('/participants/_public/invite/done')({
  component: InviteDonePage,
});

function InviteDonePage() {
  return (
    <div className="mx-auto max-w-lg px-4 py-16 text-center">
      <h1 className="text-display-xs font-semibold text-primary">
        <Trans>Thanks, you&apos;re all done</Trans>
      </h1>
      <p className="mt-3 text-md text-tertiary">
        <Trans>
          Your responses have been submitted. You can close this page.
        </Trans>
      </p>
    </div>
  );
}
